import {Inject, Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'date'
})
export class DatePipe implements PipeTransform {

  moment: any;

  constructor(@Inject('moment') moment: any){
    this.moment = moment;
  }

  transform(value: any, args?: any): any {
    return this.moment(value).format("DD/MM/YYYY");
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/shared/pipes/date.pipe.ts